<template>

    <v-step :step="step" title="Colors">
        <v-form-group label="Button Color">
            <v-input-color class="w-300" :model="form.button_color" @input="setParam({ button_color: $event })" />
        </v-form-group>
        <v-form-group label="Label Color">
            <v-input-color class="w-300" :model="form.label_color" @input="setParam({ label_color: $event })" />
        </v-form-group>
        <v-form-group label="Text Color">
            <v-input-color class="w-300" :model="form.text_color" @input="setParam({ text_color: $event })" />
        </v-form-group>
        <v-form-group label="Field Border Color">
            <v-input-color class="w-300" :model="form.field_border_color" @input="setParam({ field_border_color: $event })" />
        </v-form-group>
        <v-form-group label="Field Background Color">
            <v-input-color class="w-300" :model="form.field_background_color" @input="setParam({ field_background_color: $event })" />
        </v-form-group>
        <v-form-group label="Field Glow Color">
            <v-input-color class="w-300" :model="form.field_glow_color" @input="setParam({ field_glow_color: $event })" />
        </v-form-group>
    </v-step>

</template>

<script>

import Step from './Step';

export default {

    components: {
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    computed: {

        form() {
            return this.$store.getters['form/form'];
        },

    },

    methods: {

        setParam(param) {
            this.$store.commit('form/setParam', param);
        },

    },

}

</script>
